import { NewAgentsRotationCriteriaView } from "../../Views/Home/NewAgentsRotationCriteriaView";
import { NewAddAgentsRotationCriteriaView } from "../../Views/Home/NewAgentsRotationCriteriaView/NewAddAgentsRotationCriteriaView";

export const NewAgentsRotationCriteriaRoutes = [
  {
    path: "/view",
    name: "Agents:rotation-schema",
    component: NewAgentsRotationCriteriaView,
    layout: "/home/rotation-criteria",
    default: true,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [],
  },
  {
    path: "/add-criteria",
    name: "Agents:rotation",
    component: NewAddAgentsRotationCriteriaView,
    layout: "/home/rotation-criteria",
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [],
  },
];
